/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMixedObject = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M8 22H2v-2h6zm7 0H9v-2h6zm7 0h-6v-2h6zM8 19H2v-2h6zm7 0H9v-2h6zm7 0h-6v-2h6zM8 16H2v-2h6zm7 0H9v-2h6zm7 0h-6v-2h6zM19.5 2a2.5 2.5 0 1 1-.912 4.825l-1.763 1.763c.111.283.175.59.175.912a2.5 2.5 0 1 1-4.726-1.135l-1.096-1.462A2.49 2.49 0 0 1 10.5 7c-.39 0-.758-.093-1.087-.252l-2.522 2.02A2.5 2.5 0 0 1 4.5 12a2.5 2.5 0 1 1 1.085-4.75l2.524-2.018A2.5 2.5 0 0 1 10.5 2a2.5 2.5 0 0 1 2.226 3.634l1.095 1.46a2.49 2.49 0 0 1 1.59.08l1.763-1.763A2.5 2.5 0 0 1 19.5 2zm-15 7a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm10 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-4-5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm9 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgMixedObject as MixedObject };
